import { Check } from "@educaplay/core/Icons/Check";
import classes from "./CheckButton.module.scss";
import clsx from "clsx";
import { motion } from "framer-motion";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { useGameSounds, useTranslate } from "@educaplay/core";
import { LINE_UP_SOUND_NAMES } from "../../utils/consts";

export default forwardRef(function CheckButton(props, ref) {
  const { onClick, focusNote } = props;
  const isCompleteEntryAnimation = useSelector(
    (state) => state.game.isCompleteEntryAnimation
  );

  const gameSounds = useGameSounds();
  const t = useTranslate();

  return (
    <motion.div
      className={clsx(
        classes.buttoncontainer,
        focusNote && classes.displaymobile
      )}
      ref={ref}
      onHoverStart={() => {
        gameSounds.play(LINE_UP_SOUND_NAMES.hoverCheckButton);
      }}
    >
      <button
        disabled={!isCompleteEntryAnimation}
        className={classes.button}
        onClick={onClick}
      >
        <span className={classes.icon}>
          <Check />
        </span>
        <span className={classes.text}>{t("specific.check")}</span>
      </button>
    </motion.div>
  );
});
